import ChevronRight from '@mui/icons-material/ChevronRight';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './OrderTracker.styles';

function OrderTrackerItem({
  color,
  ctaMessageId,
  eventCallback,
  isClickable = true,
  justifyContent = 'space-between',
  onClick,
  titleMessageId,
  titleMessageSuffix = '',
  type
}) {
  const handleOnClick = () => {
    if (!isClickable) return;

    if (eventCallback) {
      eventCallback();
    }

    if (onClick) {
      onClick();
    }
  };

  const ItemContainer = isClickable
    ? Styled.StyledOrderTrackerItem
    : Styled.StyledOrderTrackerItemStatic;

  return (
    <ItemContainer
      data-testid={`order-tracker-item-${type}`}
      display="flex"
      justifyContent={justifyContent}
      width="100%"
      padding="1rem"
      onClick={isClickable ? handleOnClick : undefined}
    >
      <Text weight="medium" paddingRight="1rem">
        <FormattedMessage
          id={titleMessageId}
        />
        {titleMessageSuffix}
      </Text>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Styled.StyledChip
          color={color}
        >
          <FormattedMessage id={ctaMessageId} />
        </Styled.StyledChip>
        {isClickable && <ChevronRight />}
      </Stack>
    </ItemContainer>
  );
}

OrderTrackerItem.propTypes = {
  color: PropTypes.string.isRequired,
  ctaMessageId: PropTypes.string.isRequired,
  eventCallback: PropTypes.func,
  isClickable: PropTypes.bool,
  justifyContent: PropTypes.string,
  onClick: PropTypes.func,
  titleMessageId: PropTypes.string.isRequired,
  titleMessageSuffix: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default OrderTrackerItem;
